import { render, staticRenderFns } from "./ideaList.vue?vue&type=template&id=c61dd4b4&scoped=true&"
import script from "./ideaList.vue?vue&type=script&lang=js&"
export * from "./ideaList.vue?vue&type=script&lang=js&"
import style0 from "./ideaList.vue?vue&type=style&index=0&id=c61dd4b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61dd4b4",
  null
  
)

export default component.exports